module.exports = __webpack_public_path__ + "img/f1-2-5.da348fa9.png";